import type { NavigateFunction } from 'react-router-dom'
import type { SlackAuthResult } from '@/api/auth'
import { useAuthStore } from '@/stores/authStore'

type SetAuth = ReturnType<typeof useAuthStore.getState>['setAuth']

/**
 * Apply an "authenticated" SlackAuthResult: persist the session, then route to
 * the one-time set-password screen (first Slack login) or into the org.
 */
export function applyAuthenticated(
  result: SlackAuthResult,
  setAuth: SetAuth,
  navigate: NavigateFunction,
) {
  const u = result.user
  if (!u || !result.access_token) return
  const orgSlug = u.org_slug
  setAuth(
    {
      id: u.id,
      email: u.email,
      name: u.name,
      role: u.role as any,
      timezone: u.timezone,
      avatar_url: u.avatar_url,
      org_id: u.org_id,
      org_slug: orgSlug,
    },
    result.access_token,
    orgSlug,
  )
  if (result.must_set_password) {
    navigate('/set-password')
  } else {
    navigate(orgSlug ? `/${orgSlug}` : '/')
  }
}
